// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 11-observability.md#pod-diagnostics
// @greenlight-spec: 06-agent-interface.md#observability
import { initContract } from '@ts-rest/core';
import { AppDiagnosticsSchema } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
export const diagnosticsContract = c.router({
    get: {
        method: 'GET',
        path: '/api/apps/:id/diagnostics',
        pathParams: AppIdParamsSchema,
        responses: {
            200: AppDiagnosticsSchema,
            ...errorResponses,
        },
        summary: 'One runtime-health snapshot of a deployed app: workload and probe status, the env contract (names and status only, never values), control-plane dependency reachability, recent pod events, rollout freshness, and the rollout blocker. The REST mirror of the MCP getAppDiagnostics tool, served by the same service; a section is null when its source was unreachable.',
    },
});
//# sourceMappingURL=diagnostics.js.map